var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Routes } from '../const';
import { Status } from '../typings/paymentPlans';
import { handleError } from './handleError';
export var enrollSettlement = function (settlement, setDisablePrimary, setCurrentRoute) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setDisablePrimary(true);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, settlement.enrollment.mutateAsync(settlement.plan)];
            case 2:
                response = _a.sent();
                if (response.enrolled) {
                    setCurrentRoute(Routes.SETTLEMENT_SUCCESS);
                }
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                setCurrentRoute(Routes.SETTLEMENT_ERROR);
                return [3 /*break*/, 5];
            case 4:
                setDisablePrimary(false);
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var enrollPlan = function (_a) {
    var currentFlow = _a.currentFlow, currentRoute = _a.currentRoute, flow = _a.flow, planEnroll = _a.planEnroll, setCurrentRoute = _a.setCurrentRoute, setDisablePrimary = _a.setDisablePrimary;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setDisablePrimary(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, planEnroll.mutateAsync()];
                case 2:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.enrollmentStatus) === Status.Success) {
                        setCurrentRoute(Routes.PLAN_SUCCESS);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    handleError({ error: error_2, currentFlow: currentFlow, currentRoute: currentRoute, flow: flow, setCurrentRoute: setCurrentRoute });
                    return [3 /*break*/, 5];
                case 4:
                    setDisablePrimary(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
};
export var onInvalidate = function (_a) {
    var cacheKey = _a.cacheKey, err = _a.err, queryClient = _a.queryClient;
    if (err)
        throw err;
    queryClient.invalidateQueries(cacheKey);
};
//# sourceMappingURL=enrollment.js.map